import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TimelineHeaderContainer } from '../../styles';
import { setPickedDate } from 'redux/actions';
import colors from 'constants/colors';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';

const TimelineHeader = ({ intervals, getRootProps, getIntervalProps }) => {
  const pickedDate = useSelector(state => state.pickedDateReducer.pickedDate)
  const dispatch = useDispatch();

  // Create a ref map for all interval cells
  const cellRefs = useRef(new Map());
  const [overflowMap, setOverflowMap] = useState(new Map());

  useEffect(() => {
    const observers = [];

    cellRefs.current.forEach((el, key) => {
      if (!el) return;

      const observer = new ResizeObserver(entries => {
        requestAnimationFrame(() => {
          for (let entry of entries) {
            const isOverflow = entry.contentRect.width < 80;
            setOverflowMap(prev => {
              if (prev.get(key) === isOverflow) return prev;
              const newMap = new Map(prev);
              newMap.set(key, isOverflow);
              return newMap;
            });
          }
        });
      });

      observer.observe(el);
      observers.push(observer);
    });

    return () => observers.forEach(o => o.disconnect());
  }, [intervals]);

  return (
    <TimelineHeaderContainer
      {...(() => {
        const { key, ...rest } = getRootProps();
        return rest;
      })()}
      key={(() => {
        const { key } = getRootProps();
        return key;
      })()}
    >
      {intervals.map(interval => {
        const intervalKey = interval.startTime.valueOf();

        const setCellRef = el => {
          if (el) cellRefs.current.set(intervalKey, el);
        };

        const isOverflowing = overflowMap.get(intervalKey) || false;

        const { key: intervalPropKey, ...intervalProps } =
          getIntervalProps({
            interval,
            style: {
              height: "50px",
              textAlign: "left",
              borderTop: `2px solid ${colors.dimGrey}`,
              borderBottom: `2px solid ${colors.dimGrey}`,
              borderRight: `1px solid ${colors.charcoal}`,
              cursor: "pointer",
              backgroundColor: colors.black1,
              fontSize: "12px",
              fontWeight: "bold",
              padding: "0 10px",
              letterSpacing: "1px",
              color: colors.silver,
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            },
          });

        const date = interval.startTime.format("MMM Do YYYY");
        const weekday = interval.startTime.format("dddd");

        return (
          <div
            key={intervalPropKey}
            ref={setCellRef}
            className={
              moment(pickedDate).tz(TIME_ZONE).format("MMM Do YYYY") === date
                ? "today"
                : null
            }
            onClick={() => {
              dispatch(
                setPickedDate(
                  moment(interval.startTime).tz(TIME_ZONE).valueOf()
                )
              );
            }}
            {...intervalProps}
          >
            <div className="timeline-header-cell">
              {!isOverflowing && <div className="weekday">{weekday}</div>}
              <div className="date">{date}</div>
            </div>
          </div>
        );
      })}
    </TimelineHeaderContainer>
  );
};

export default TimelineHeader;
